// @ts-nocheck
/**
 * MRO Header v2 — Premium
 * ─ Offset dinámico (header fixed)
 * ─ Shrink on scroll
 * ─ Mobile drawer (hamburger)
 * ─ Drawer submenu accordion
 * ─ Announcement bar dismiss
 * ─ Cart badge live update
 * ─ Cart pulse animation
 */
(function () {
  'use strict';

  const header  = document.querySelector('[data-mro-header]');
  if (!header) return;

  const main    = document.querySelector('#MainContent') || document.querySelector('main');
  const overlay = document.querySelector('[data-mro-overlay]');
  const drawer  = document.querySelector('[data-mro-drawer]');

  /* ─────────────────────────────────────────
     1. HEADER OFFSET (empuja el contenido)
  ───────────────────────────────────────── */
  function applyOffset() {
    const h = header.offsetHeight || 0;
    if (main) main.style.paddingTop = h + 'px';
    else document.body.style.paddingTop = h + 'px';
  }

  /* ─────────────────────────────────────────
     2. SHRINK ON SCROLL
  ───────────────────────────────────────── */
  function onScroll() {
    header.classList.toggle('is-stuck', window.scrollY > 10);
  }

  /* ─────────────────────────────────────────
     3. MOBILE DRAWER
  ───────────────────────────────────────── */
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay && overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';

    // Focus trap — move focus to close button
    const closeBtn = drawer.querySelector('[data-mro-drawer-close]');
    closeBtn && closeBtn.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay && overlay.classList.remove('is-visible');
    document.body.style.overflow = '';

    // Return focus to hamburger
    const ham = header.querySelector('[data-mro-drawer-open]');
    ham && ham.focus();
  }

  // Open triggers
  header.querySelectorAll('[data-mro-drawer-open]').forEach(btn => {
    btn.addEventListener('click', openDrawer);
  });

  // Close triggers
  header.querySelectorAll('[data-mro-drawer-close]').forEach(btn => {
    btn.addEventListener('click', closeDrawer);
  });

  // Overlay click
  overlay && overlay.addEventListener('click', closeDrawer);

  // ESC key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  /* ─────────────────────────────────────────
     4. DRAWER SUBMENU ACCORDION
  ───────────────────────────────────────── */
  if (drawer) {
    drawer.querySelectorAll('.mro-drawer__sub-toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const isExpanded = btn.getAttribute('aria-expanded') === 'true';
        const subnav = btn.closest('.mro-drawer__nav-item').querySelector('.mro-drawer__subnav');

        // Close all other open submenus
        drawer.querySelectorAll('.mro-drawer__sub-toggle[aria-expanded="true"]').forEach(function (other) {
          if (other !== btn) {
            other.setAttribute('aria-expanded', 'false');
            const otherSub = other.closest('.mro-drawer__nav-item').querySelector('.mro-drawer__subnav');
            if (otherSub) otherSub.hidden = true;
          }
        });

        btn.setAttribute('aria-expanded', String(!isExpanded));
        if (subnav) subnav.hidden = isExpanded;
      });
    });
  }

  /* ─────────────────────────────────────────
     5. ANNOUNCEMENT BAR DISMISS
  ───────────────────────────────────────── */
  const annBar   = header.querySelector('[data-mro-ann]');
  const annClose = header.querySelector('[data-mro-ann-close]');

  if (annClose && annBar) {
    // Restore from session storage
    if (sessionStorage.getItem('mro-ann-hidden') === '1') {
      annBar.classList.add('is-hidden');
    }

    annClose.addEventListener('click', function () {
      annBar.classList.add('is-hidden');
      sessionStorage.setItem('mro-ann-hidden', '1');
      // Recalculate offset after animation
      setTimeout(applyOffset, 400);
    });
  }

  /* ─────────────────────────────────────────
     6. CART BADGE
  ───────────────────────────────────────── */
  async function getCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    return res.json();
  }

  function setBadge(count) {
    const cartIcon = header.querySelector('.mro-header__icon--cart');
    if (!cartIcon) return;
    let badge = cartIcon.querySelector('.mro-header__badge');

    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'mro-header__badge';
        badge.setAttribute('aria-hidden', 'true');
        cartIcon.appendChild(badge);
      }
      badge.textContent = count > 99 ? '99+' : String(count);
    } else {
      if (badge) badge.remove();
    }

    // Update aria-label
    cartIcon.setAttribute(
      'aria-label',
      count > 0 ? 'Carrito (' + count + ' artículos)' : 'Carrito'
    );
  }

  /* ─────────────────────────────────────────
     7. CART PULSE
  ───────────────────────────────────────── */
  function pulseCart() {
    header.classList.add('mro-cart-pulse');
    setTimeout(() => header.classList.remove('mro-cart-pulse'), 520);
  }

  /* ─────────────────────────────────────────
     8. INTERCEPT FETCH — detectar add to cart
  ───────────────────────────────────────── */
  const _fetch = window.fetch;
  window.fetch = async function (...args) {
    const res = await _fetch.apply(this, args);
    try {
      const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      if (url.includes('/cart/add')) {
        const cart = await getCart();
        setBadge(cart.item_count);
        pulseCart();
        applyOffset();
      }
    } catch (_) { /* silently ignore */ }
    return res;
  };

  /* ─────────────────────────────────────────
     9. INIT
  ───────────────────────────────────────── */
  applyOffset();
  onScroll();

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', applyOffset, { passive: true });
  window.addEventListener('load',   applyOffset);

  // Initial cart count
  getCart().then(c => setBadge(c.item_count)).catch(() => {});
})();
